import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { FlashProvider } from "@ziolo/ui";
import "@ziolo/ui/styles.css";
import "./styles/hub.css";
import { App } from "./App.js";
import { SessionProvider } from "./session/SessionProvider.js";

const container = document.getElementById("root");
if (!container) {
  throw new Error("#root is missing from index.html");
}

createRoot(container).render(
  <StrictMode>
    <FlashProvider>
      <SessionProvider>
        <App />
      </SessionProvider>
    </FlashProvider>
  </StrictMode>,
);
